var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 75,
    viewBox: "0 0 71 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7972 30.5049C62.1069 30.7204 68.6996 37.6786 68.6996 46.1299C68.6995 48.1358 67.9741 50.4237 67.0121 52.6426C66.0296 54.9086 64.7051 57.3147 63.3158 59.6162C60.5714 64.1627 57.3527 68.6445 55.9574 70.7881L55.9564 70.7891C54.7451 72.648 52.0545 72.6483 50.8431 70.7891V70.7881C49.4479 68.6447 46.2283 64.1629 43.4838 59.6162C42.0945 57.3147 40.7709 54.9086 39.7885 52.6426C38.8264 50.4236 38.1001 48.1358 38.1 46.1299L38.1049 45.7285C38.3127 37.3258 45.0367 30.5001 53.3998 30.5L53.7972 30.5049Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4 32.5C60.7454 32.5 66.7 38.6021 66.7 46.1294C66.6999 52.4747 57.2492 65.1368 54.2808 69.6972C53.8584 70.3454 52.9415 70.3454 52.5192 69.6972C49.5507 65.1368 40.1001 52.4747 40.1 46.1294C40.1 38.6021 46.0546 32.5 53.4 32.5ZM53.4 40.8869C50.5748 40.8869 48.2842 43.2343 48.2842 46.1294C48.2842 49.0245 50.5749 51.372 53.4 51.372C56.2251 51.372 58.5157 49.0245 58.5158 46.1294C58.5158 43.2343 56.2251 40.8869 53.4 40.8869Z",
    fill: "#E7332F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4 40.8869C50.5748 40.8869 48.2842 43.2343 48.2842 46.1294C48.2842 49.0245 50.5749 51.372 53.4 51.372C56.2251 51.372 58.5157 49.0245 58.5158 46.1294C58.5158 43.2343 56.2251 40.8869 53.4 40.8869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0156 2.00879C41.7607 2.36538 52.7178 13.8822 52.7178 27.9375C52.7177 31.1433 51.5452 34.9298 49.8779 38.7754C48.1903 42.668 45.9016 46.8287 43.4785 50.8428C38.6665 58.8144 33.0997 66.553 30.582 70.4209H30.5811C29.0982 72.6966 25.8768 72.7684 24.2852 70.6348L24.1357 70.4209C21.618 66.553 16.0504 58.8145 11.2383 50.8428C8.8152 46.8287 6.52746 42.668 4.83984 38.7754C3.1726 34.9298 2.00006 31.1433 2 27.9375L2.00781 27.2705C2.35337 13.2978 13.5269 2.00027 27.3584 2L28.0156 2.00879Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3588 4C40.2596 4 50.7176 14.7171 50.7176 27.9374C50.7175 39.0815 34.1192 61.32 28.9057 69.3295C28.164 70.4679 26.5536 70.4679 25.8119 69.3295C20.5984 61.32 4.00016 39.0815 4 27.9374C4 14.7171 14.4581 4.00004 27.3588 4ZM27.3588 18.73C22.397 18.73 18.3739 22.8527 18.3739 27.9374C18.3741 33.0221 22.3971 37.1449 27.3588 37.1449C32.3206 37.1449 36.3436 33.0221 36.3437 27.9374C36.3437 22.8527 32.3206 18.73 27.3588 18.73Z",
    fill: "#E7332F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3588 18.73C22.397 18.73 18.3739 22.8527 18.3739 27.9374C18.3741 33.0221 22.3971 37.1449 27.3588 37.1449C32.3206 37.1449 36.3436 33.0221 36.3437 27.9374C36.3437 22.8527 32.3206 18.73 27.3588 18.73Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedVehicles);
export default __webpack_public_path__ + "static/media/completedVehicles.39645df8b2cd304a24abb66a81620f50.svg";
export { ForwardRef as ReactComponent };